define(function(require, exports, module) {
    'use strict';

    module.exports = {

        init: function(widget) {
            var $el = widget.$el;

            if ($el.hasClass('accordion-animate')) {
                return;
            }

            $el.originalAddClass('accordion-animate');
        }

    };
});
